import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PagedResponse, ObjectResponse } from '../../interfaces';
import { AppConfig } from '../app-config';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseHttpService<T> {
  constructor(protected http: HttpClient, protected config: AppConfig) { }

  public show(id: number): Observable<any> {
    // TODO: update to .get<ObjectResponse<T>
    return this.http.get<any>(`${this.getResourceUrl()}${id}`);
  }

  public list(queryString?: string): Observable<any> {
    const apiUrl = this.applyQueryString(queryString);
    // TODO: update to be .get<PagedResponse<T>> after whole API is updated
    // maybe add another one without count (ListResponse<T>)
    return this.http.get<any>(apiUrl);
  }

  public listWithCount(queryString?: string): Observable<PagedResponse<T>> {
    const apiUrl = this.applyQueryString(queryString);

    return this.http.get<PagedResponse<T>>(apiUrl);
  }

  public save(model: T): Observable<ObjectResponse<T>> {
    return this.http.post<ObjectResponse<T>>(this.getResourceUrl(), model);
  }

  public edit(id: number, model: T): Observable<any> {
    // TODO: update to .patch<ObjectResponse<T>
    return this.http.patch(`${this.getResourceUrl()}${id}`, model);
  }

  public delete(id: number): Observable<any> {
    // TODO: update to .delete<ObjectResponse<T>
    return this.http.delete(`${this.getResourceUrl()}${id}`);
  }

  public put(model: T): Observable<any> {
    // TODO: update to .put<ObjectResponse<T>
    return this.http.put(`${this.getResourceUrl()}`, model);
  }

  protected applyQueryString(queryString: string, baseUrl?: string): string {
    let apiUrl = baseUrl || this.getResourceUrl();
    if (!!queryString) {
      apiUrl += queryString;
    }

    return apiUrl;
  }

  protected abstract getResourceUrl(): string;
}
